import { render, staticRenderFns } from "./AddFollowerConfig.vue?vue&type=template&id=373644c8&scoped=true"
import script from "./AddFollowerConfig.vue?vue&type=script&lang=js"
export * from "./AddFollowerConfig.vue?vue&type=script&lang=js"
import style0 from "./AddFollowerConfig.vue?vue&type=style&index=0&id=373644c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373644c8",
  null
  
)

export default component.exports